/**
 * Algolia Widget Builder functions
 *
 **/
 import { debounce } from 'lodash'

custom.algoliaWidgetBuilder = (function () {
  // Create the render function
  const createDataAttribtues = (refinement) =>
    Object.keys(refinement)
      .map((key) => {
        if (
          (key === 'value' || key === 'label') &&
          refinement[key] &&
          typeof refinement[key] === 'string'
        ) {
          return `data-${key}="${refinement[key].replace(/"/g, '&quot;')}"`;
        }
        return `data-${key}="${refinement[key]}"`;
      })
      .join(' ');

  const renderListItem = (item) => `
    ${item.refinements
      .map(
        (refinement) =>
          `<div class="ais-current-refined-values--item">
            <button class="ais-current-refined-values--link" ${createDataAttribtues(
              refinement,
            )}><div>${refinement.attribute == 'named_tags.Timestamp' ? 'New Arrivals' : refinement.label}<span class="sr-only">(${
            refinement.count
          })</span></div></button>
          </div>`,
      )
      .join('')}
`;

  const renderCurrentRefinements = (renderOptions, isFirstRender) => {
    const { items, refine, widgetParams } = renderOptions;
    const widgetContainer = document.querySelector(widgetParams.container);
    if (isFirstRender) {
      const root = document.createElement('div');
      root.className = `ais-root ais-current-refined-values`;
      const body = document.createElement('div');
      body.className = 'ais-body ais-current-refined-values--body';
      const list = document.createElement('div');
      list.className = `ais-current-refined-values--list`;
      list.id = `${widgetParams.container}--list`;

      body.appendChild(list);
      root.appendChild(body);
      widgetContainer.appendChild(root);
    }
    const itemsList = document.getElementById(
      `${widgetParams.container}--list`,
    );
    const itemHtml = items
      .map((item) => {
        return renderListItem(item);
      })
      .join('');
    itemsList.innerHTML = itemHtml;

    const toggleButtons = itemsList.querySelectorAll(
      '.ais-current-refined-values--link',
    );

    [...toggleButtons].forEach((element) => {
      element.addEventListener('click', (event) => {
        const item = Object.keys(event.currentTarget.dataset).reduce(
          (acc, key) => ({
            ...acc,
            [key]: event.currentTarget.dataset[key],
          }),
          {},
        );

        refine(item);
      });
    });
  };

  const newArrivalsToggle = (renderOptions, isFirstRender) => {
    const { items, refine, widgetParams } = renderOptions;

    if (isFirstRender) {
      const root = document.createElement('div');
      root.className = `ais-root ais-RefinementList`;
      const body = document.createElement('div');
      body.className = 'ais-body ais-RefinementList--body';
      const list = document.createElement('div');
      body.style = 'max-height: none;';
      list.className = `ais-RefinementList--list ais-refinement-list--list full-width-container`;

      body.appendChild(list);
      root.appendChild(body);
      widgetParams.container.appendChild(root);
    }
    widgetParams.container.querySelector(
      '.ais-RefinementList--list',
    ).innerHTML = items
      .map((item) => custom.algoliaUtils.itemTemplate(item))
      .join('');

    [...widgetParams.container.querySelectorAll('label')].forEach((element) => {
      element.addEventListener('click', debounce(function (event) {
          const isRefined = event.target.checked;
          isRefined == true ? refine(event.target.value) : refine("%7B%7D");
      }, 10));
    });
  }
  const renderPriceMenu = (renderOptions, isFirstRender) => {
    // Use `hasNoResults` in earlier minor versions.
    const { items, refine, widgetParams } = renderOptions;

    if (isFirstRender) {
      const root = document.createElement('div');
      root.className = `ais-root ais-RefinementList`;
      const header = document.createElement('div');
      header.className = 'ais-RefinementList--header ais-header';
      header.innerHTML = `<span class="tippy-container">Price <span class="tippy-icon inline-block relative js-tippy" title="$ = < $499 <br>$$ = $500-$999 <br>$$$ = $1000-$1999 <br>$$$$ = > $2000 <br>*Based on MSRP of approximate 5’ x 8’ size."><span class="inline-block border border-primary rounded-full w-4 h-4 text-center">?</span></span></span>`;
      const body = document.createElement('div');
      body.className = 'ais-body ais-RefinementList--body';
      const list = document.createElement('div');
      list.className = `ais-RefinementList--list ais-refinement-list--list full-width-container`;

      body.appendChild(list);

      root.appendChild(header);
      root.appendChild(body);
      widgetParams.container.appendChild(root);
    }

    widgetParams.container.querySelector(
      '.ais-RefinementList--list',
    ).innerHTML = items
      .map((item) => custom.algoliaUtils.itemTemplate(item))
      .join('');

    [...widgetParams.container.querySelectorAll('label')].forEach((element) => {
      element.addEventListener('click', debounce(function (event) {
          refine(event.target.value);
      }, 10));
    });
  };

  /**
   * buildWidget
   * @params {myInstantSearch} object - InstantSearch instance
   * @params {instantsearch} Object - Algolia instantsearch object
   * @params {widgetType} str - type of widget to build
   * @params {widgetOptions} Object - Options for the widget
   */
  function buildWidget(
    myInstantSearch,
    instantsearch,
    widgetType,
    widgetOptions,
  ) {
    if (widgetType === 'currentRefinedValues') {
      const customCurrentRefinements =
        instantsearch.connectors.connectCurrentRefinements(
          renderCurrentRefinements,
        );
      const filteredAttributes = widgetOptions.attributes.map(function (item) {
        return item['name'];
      });
      // Instantiate the custom widget
      myInstantSearch.addWidgets([
        customCurrentRefinements({
          container: widgetOptions.container,
          includedAttributes: filteredAttributes,
        }),
      ]);
      return;
    }
    if (widgetType === 'clearRefinements') {
      myInstantSearch.addWidgets([
        instantsearch.widgets.clearRefinements({
          container: widgetOptions.container,
          includedAttributes: widgetOptions.attributes,
          templates: {
            resetLabel({ hasRefinements }, { html }) {
              return html`<span
                >${hasRefinements ? 'Clear all' : 'No refinements'}</span
              >`;
            },
          },
        }),
      ]);
      return;
    }
    if (widgetType === 'stats') {
      myInstantSearch.addWidgets([instantsearch.widgets.stats(widgetOptions)]);
      return;
    }

    if (widgetType === 'sortBySelector') {
      myInstantSearch.addWidgets([instantsearch.widgets.sortBy(widgetOptions)]);
      return;
    }

    if (widgetType === 'refinementListBasic') {
      myInstantSearch.addWidgets([
        instantsearch.widgets.refinementList(widgetOptions),
      ]);
      return;
    }

    //refinementList builder
    if (widgetType === 'refinementList') {
      const renderRefinementList = (renderOptions, isFirstRender) => {
        const isColorWidget = widgetOptions.attribute === 'named_tags.Color';
        const { items, refine, widgetParams } = renderOptions;

        if (isFirstRender) {
          if (!widgetOptions.cssClasses) {
            widgetOptions.cssClasses = {};
          }
          const headerClasses = `ais-RefinementList--header ais-header  ${
            widgetOptions.cssClasses.header
              ? widgetOptions.cssClasses.header
              : ''
          }`;
          const listClasses = `ais-RefinementList--list ais-refinement-list--list ${
            widgetOptions.cssClasses.list ? widgetOptions.cssClasses.list : ''
          }`;
          const bodyClasses = `ais-body ais-RefinementList--body  ${
            widgetOptions.cssClasses.body ? widgetOptions.cssClasses.body : ''
          }`;
          const rootClasses = `ais-root ais-RefinementList  ${
            widgetOptions.cssClasses.root ? widgetOptions.cssClasses.root : ''
          }`;
          const root = document.createElement('div');
          root.className = rootClasses;
          const header = document.createElement('div');
          header.className = headerClasses;
          const body = document.createElement('div');
          body.className = bodyClasses;
          const list = document.createElement('div');
          list.className = listClasses;

          body.appendChild(list);

          root.appendChild(header);
          root.appendChild(body);
          widgetParams.container.appendChild(root);
        }

        let filterItems = items.sort((a, b) =>
          a.label > b.label ? 1 : b.label > a.label ? -1 : 0,
        );

        if (widgetOptions.sortBy && typeof widgetOptions.sortBy == 'function') {
          filterItems = items.sort((a, b) => widgetOptions.sortBy(a, b));
        }

        widgetParams.container.querySelector(
          '.ais-RefinementList--list',
        ).innerHTML = items
          .map((item) =>
            isColorWidget
              ? custom.algoliaUtils.colorTemplate(item)
              : custom.algoliaUtils.itemTemplate(item),
          )
          .join('');

        const refinedCount = items.filter((item) => item.isRefined).length;

        const headerTitle = custom.algoliaUtils.getHeaderLabel(
          widgetOptions.attribute,
          refinedCount,
        );

        const hasRefinementOptions = items.length > 0;
        if (hasRefinementOptions) {
          widgetParams.container.classList.remove('hidden');
        } else {
          widgetParams.container.classList.add('hidden');
        }

        widgetParams.container.querySelector(
          '.ais-RefinementList--header',
        ).innerHTML = headerTitle;

        const searchTarget = isColorWidget ? 'a' : 'label';

        [...widgetParams.container.querySelectorAll(searchTarget)].forEach(
          (element) => {
            element.addEventListener('click', (event) => {
              event.preventDefault();
              refine(event.currentTarget.dataset.value);
            });
          },
        );
      };

      const customRefinementList =
        instantsearch.connectors.connectRefinementList(renderRefinementList);
      myInstantSearch.addWidgets([
        customRefinementList({
          container: document.querySelector(widgetOptions.container),
          attribute: widgetOptions.attribute,
          limit: 40,
          showMoreLimit: 100,
        }),
      ]);
      return;
    }
    if (widgetType === 'numericMenu') {
      // Create the custom widget
      const customNumericMenu =
        instantsearch.connectors.connectNumericMenu(renderPriceMenu);

      // Instantiate the custom widget
      myInstantSearch.addWidgets([
        customNumericMenu({
          container: document.querySelector(widgetOptions.container),
          attribute: widgetOptions.attribute,
          items: widgetOptions.items,
        }),
      ]);
      return;
    }
    if (widgetType === 'newArrivalsMenu') {
      // Create the custom widget
      const customNewArrivalsMenu =
        instantsearch.connectors.connectNumericMenu(newArrivalsToggle);

      // Instantiate the custom widget
      myInstantSearch.addWidgets([
        customNewArrivalsMenu({
          container: document.querySelector(widgetOptions.container),
          attribute: widgetOptions.attribute,
          items: widgetOptions.items,
        }),
      ]);
      return;
    }
    if (widgetType === 'searchBox') {
      myInstantSearch.addWidgets([
        instantsearch.widgets.searchBox({
          container: document.querySelector(widgetOptions.container),
          placeholder: widgetOptions.placeholder,
          queryHook: widgetOptions.queryHook,
          showSubmit: false,
          showReset: false,
        }),
      ]);
      return;
    }
    if (typeof instantsearch.widgets[widgetType] !== 'undefined') {
      myInstantSearch.addWidgets([
        instantsearch.widgets[widgetType](widgetOptions),
      ]);
      return;
    }
    console.log('widget type undefined', widgetType);
  }

  return {
    buildWidget,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/algolia-widget-builder.js